import { present, length, runValidations } from '../base.validations';

const attributeValidators = {
  title: [ { validation: present}, { validation: length, additional_conditions: { max_length: 100 }}]
}

export function subheadingValidations(subheading) {
  return runValidations(subheading, attributeValidators);
}
